import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../../../components/Converter";
import Dash from "../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import { ALPHA_EQUAL_A_ZERO } from "../../../../../constants";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../../../../store/slices/bemessungenMikropfaehleSlice";

function Imperfektionsbeiwert() {
  const { t } = useTranslation("translation");
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.imperfectionFactor")}</p>}
      indicesValue={<span>&alpha;</span>}
      inputValue={<span className="input">{ConvertToString(ALPHA_EQUAL_A_ZERO)}</span>}
      unitValue={<Dash />}
      formulaValue={
        <ToolTip
          id={"Imperfektionsbeiwert"}
          type={IconType.INFO}
          text={
            <Trans
              i18nKey={
                bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
                  ? "inner.buckling.ofner.parameterTragglied.imperfectionFactor_InfoText_ec7"
                  : "inner.buckling.ofner.parameterTragglied.imperfectionFactor_InfoText"
              }
              values={{ unit: "a<sub>0</sub>" }}
              components={{ sub: <sub /> }}
            />
          }
        />
      }
    />
  );
}

export default Imperfektionsbeiwert;
